<template>
  <li class="concept-menu" :class="{hovered: isHover}" @mouseenter="handleEnter" @mouseleave="handleLeave">
    <a href="#" @click="handleClick" :class="{current: !!active}">{{$t('topbar.menu.concept.button').toUpperCase()}}</a>
    <div class="concept-sub-menu">
      <div class="sub-menu">
        <ul id="concept">
          <li v-for="(item, index) in menu">
            <div class="menu-header" @click="redirectToConcept(item.id, item.text.title)">
              <img :src="item.icon + '?w=100&h=100'" alt="" class="icon"/>
              <h4>{{item.text.title}}</h4>
            </div>
            <div class="content-wrapper">
              <p>{{item.text.content}}</p>
            </div>
            <div class="footer-image">
              <img :src="`${item.picture + '?w=' + handleWidth + '&h='+ handleHeight}&crop-to-fit`"/>
            </div>
            <div class="footer-link">
              <a @click="redirectToConcept(item.id, item.text.title)"
                 class="btn std-btn card-button">{{$t('topbar.menu.concept.learn')}}</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </li>
</template>

<script>
  import {mapState} from 'vuex';
  import {TextHelper} from "../../helpers/text.helper";
  import ReloadableRouterLink from "../reloadable-router-link";

  export default {
    name: 'concept-menu',
    components: {ReloadableRouterLink},
    props: ['active'],
    data() {
      return {
        isHover: false,
        windowWidth: window.innerWidth,
        width: "",
        height: "",

      }
    },
    computed: {
      handleWidth() {
        const w = this.windowWidth;
        switch (true) {
          case (w >= 1440):
            return this.width = 600;
          case (w < 1440 && w >= 1200):
            return this.width = 500;
          case (w < 1200):
            return this.width = 400;
        }
      },
      handleHeight() {
        const w = this.windowWidth;
        switch (true) {
          case (w >= 1440):
            return this.width = 338;
          case (w < 1440 && w >= 1200):
            return this.width = 282;
          case (w < 1200):
            return this.width = 225;
        }
      },
      ...mapState({
        menu: s => s.menu.concept,
      }),
    },
    watch: {
      $route(to, from) {
        if (to.params.conceptMenuId !== from.params.conceptMenuId && to.name === from.name) {
          this.$store.dispatch('conceptPage/fetch', this.$route.params);
        }
      },
    },
    methods: {
      slug(text) {
        return TextHelper.slugify(text);
      },
      handleClick(e) {
        this.$emit('click', e);
      },
      handleEnter() {
        this.isHover = true;
      },
      handleLeave() {
        this.isHover = false;
      },
      redirectToConcept(id, slug) {
        this.handleLeave();
        this.$router.push({name: "concept2", params: {conceptMenuId: id, slug: this.slug(slug)}}).catch(err => {
        });
      },
    }
  };
</script>


<style scoped>
  .notActive {
    pointer-events: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/topbar/concept-menu.vue